import { inject, Injectable, NgZone } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class DropdownScrollMonitorService {
  private readonly dropdowns = new Set<NgbDropdown>();
  private initialized = false;
  private readonly zone = inject(NgZone);

  private initScrollHandler() {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.zone.runOutsideAngular(() => {
      window.addEventListener('scroll', (event) => this.handleScroll(event), true);
    });
  }

  handleScroll(event: Event) {
    const target = event.target as HTMLElement;

    if (!target || typeof target.closest != 'function') {
      return;
    }

    if (target.closest('.dropdown-menu')) {
      return;
    }

    this.zone.run(() => {
      this.dropdowns.forEach((dropdown) => {
        if (dropdown.isOpen()) {
          dropdown.close();
        }
      });
    });
  }

  register(dropdown: NgbDropdown) {
    this.dropdowns.add(dropdown);
    this.initScrollHandler();
  }

  unregister(dropdown: NgbDropdown) {
    this.dropdowns.delete(dropdown);
  }
}
